import { Eye, Shield, Target, Phone } from "lucide-react";

const KinekSzolSection = () => {
  const points = [
    { num: "1.", text: "Mit csinálsz" },
    { num: "2.", text: "Kinek" },
    { num: "3.", text: "Miért te vagy a jó választás" },
    { num: "4.", text: "Mit tegyen most (hívás / ajánlatkérés / időpont)" }
  ];

  const timelineSteps = [
    { icon: Eye, title: "Figyelem", desc: "5–10 mp alatt értse." },
    { icon: Shield, title: "Bizalom", desc: "Bizonyíték + folyamat." },
    { icon: Target, title: "Döntés", desc: "Egy ajánlat, egy CTA." },
    { icon: Phone, title: "Kapcsolat", desc: "Űrlap/hívás 2 kattintás." }
  ];

  const industries = [
    "Zárszerviz", "Klímaszerelés", "Villanyszerelés", "Fogászat", 
    "Szépségipar", "Könyvelés", "Ingatlanos", "Autókozmetika",
    "Takarítás", "Magánoktatás", "Edző/masszázs", "Fotós", "Jogi szolgáltatás"
  ];

  return (
    <section data-testid="kinek-szol-section" className="light-band py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-ink-text leading-tight">
            Ha szolgáltatóként ügyfeleket akarsz,{" "}
            <span className="text-primary">ez az a weboldal-típus</span>, amit keresel
          </h2>

          <p className="scroll-animate mt-6 text-muted-text text-base sm:text-lg max-w-3xl mx-auto">
            A legtöbb szolgáltatásnál nem a 20 menüpontos, vállalati "mindent is" oldal hozza a pénzt.
          </p>

          {/* Question-Answer visual connection */}
          <div className="scroll-animate mt-10 relative">
            {/* The question box */}
            <div className="relative mx-auto max-w-2xl">
              <div className="bg-gradient-to-r from-primary to-accent p-[2px] rounded-2xl">
                <div className="bg-page-bg rounded-2xl px-6 py-4 text-center">
                  <p className="text-ink-text font-semibold text-lg sm:text-xl">
                    A pénzt az hozza, ha a látogató 5–10 másodperc alatt megérti, hogy:
                  </p>
                </div>
              </div>
              {/* Arrow pointing down */}
              <div className="flex justify-center -mb-2">
                <div className="w-0 h-0 border-l-[12px] border-l-transparent border-r-[12px] border-r-transparent border-t-[12px] border-t-primary mt-[-1px]"></div>
              </div>
            </div>

            {/* Connecting line */}
            <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-[2px] h-6 bg-gradient-to-b from-primary to-transparent"></div>
          </div>

          {/* Answer cards */}
          <div className="scroll-animate-stagger scroll-animate grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
            {points.map((point, i) => (
              <div
                key={i}
                className="card-light rounded-2xl p-6 text-center hover:-translate-y-1 transition-transform"
              >
                <span className="text-4xl font-sora font-bold text-primary/30">{point.num}</span>
                <p className="mt-2 font-semibold text-ink-text text-lg">{point.text}</p>
              </div>
            ))}
          </div>

          {/* Process + Industries - ONE card with shadow */}
          <div className="scroll-animate mt-10 card-light rounded-2xl p-6 md:p-8">
            
            {/* 1) Konverziós logika - mini headline + subtitle */}
            <div className="text-center mb-8">
              <h3 className="font-sora font-bold text-xl md:text-2xl text-ink-text">
                Konverziós logika
              </h3>
              <p className="mt-2 text-muted-text text-sm md:text-base">
                Minden szekció egy kérdésre válaszol — ezért nem esik szét a figyelem.
              </p>
            </div>

            {/* 2) Timeline - 4 mini cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
              {timelineSteps.map((step, i) => (
                <div 
                  key={i} 
                  className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl p-4 text-center border border-primary/10"
                >
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
                    <step.icon size={20} className="text-primary" />
                  </div>
                  <h4 className="font-semibold text-ink-text text-sm md:text-base">{step.title}</h4>
                  <p className="text-muted-text text-xs md:text-sm mt-1">{step.desc}</p>
                </div>
              ))}
            </div>

            {/* Divider */}
            <div className="my-6 border-t border-ink-text/5"></div>

            {/* 3) Tipikus ügyfeleink - Industries */}
            <div className="text-center">
              <h3 className="font-sora font-bold text-xl md:text-2xl text-ink-text">
                Tipikus ügyfeleink
              </h3>
              <p className="mt-2 text-muted-text text-sm md:text-base mb-6">
                Szolgáltatók, ahol a gyors döntés számít.
              </p>
              
              {/* All industries */}
              <div className="flex flex-wrap justify-center gap-3">
                {industries.map((industry, i) => (
                  <span
                    key={i}
                    className="px-5 py-2.5 rounded-xl text-sm bg-white text-ink-text font-medium shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 cursor-default"
                  >
                    {industry}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KinekSzolSection;
